if (!customElements.get("td-marquee")) {
  class TDMarquise extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector(".td-track");
    }

    connectedCallback() {
      if (!this.track) return;
      this.trackWidth = this.track.offsetWidth;
      this.duplicateTrackIfNeeded();
      window.addEventListener("resize", () => this.duplicateTrackIfNeeded());
    }

    duplicateTrackIfNeeded() {
      if (this.trackWidth < window.innerWidth * 4) {
        do {
          const newTrack = this.track.cloneNode(true);
          this.track.parentNode.appendChild(newTrack);
          this.trackWidth += this.track.offsetWidth;
        } while (this.trackWidth < window.innerWidth * 4);
      }
    }
  }
  customElements.define("td-marquee", TDMarquise);
}